import { render, staticRenderFns } from "./usdtWithdraw.vue?vue&type=template&id=54c2efad&scoped=true&"
import script from "./usdtWithdraw.vue?vue&type=script&lang=js&"
export * from "./usdtWithdraw.vue?vue&type=script&lang=js&"
import style0 from "./usdtWithdraw.vue?vue&type=style&index=0&id=54c2efad&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c2efad",
  null
  
)

export default component.exports